module.exports = __webpack_public_path__ + "static/media/Generic.a90a756d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/Generic.png
// module id = 1337
// module chunks = 3